<template>
  <div class="ws-radio-list" :class="flex">
    <div class="radio-child " v-for="(item, index) in list" :key="item.name" @click="isCurrent(index, item)">
      <slot name="default" :item="item" :index="index" :current="radio.current" :parent="parent" :parentCn="parentCn">
        <el-popover placement="top-start" :content="item.name" width="auto" popper-style="line-height: 0px"
          trigger="hover">
          <template #reference>
            <div class="flex-center" style="align-items: baseline!important;" :style="style(index, item)"
              :class="radio.current === index ? 'act' : 'un-act'">
              <div class="ws-title-status" v-if="!item.url">
                <span class="text-row-1">
                  <span v-if="noKey">{{ item }}</span>
                  <span v-else>{{ item[label] }}</span>
                </span>
              </div>
              <el-image v-if="item.url" style="width:60px; height:60px" :src="item.url" fit="fill" />
            </div>
          </template>
        </el-popover>
      </slot>
    </div>
    <slot name="right">
      <div class="slotRight"></div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    modelValue: {
      type: [String, Number],
      default: undefined
    },
    list: {
      type: Array,
      default: () => []
    },
    label: {
      type: [String, Number],
      default: 'name'
    },
    value: {
      type: [String, Number],
      default: 'value'
    },
    keys: {
      type: [String, Number],
      default: 'id'
    },
    noKey: {
      type: Boolean,
      default: false
    },
    isDouble: {
      type: Boolean,
      default: false
    },
    current: {
      type: Number,
      default: -1
    },
    item: {
      type: null,
      default: undefined
    },
    height: {
      type: String,
      default: 'auto'
    },
    textWidth: {
      type: String,
      default: 'auto'
    },
    space: {
      type: String,
      default: '5px'
    },
    right: {
      type: String,
      default: '15px'
    },
    bottom: {
      type: String,
      default: '5px'
    },
    radius: {
      type: String,
      default: '4px'
    },
    border: {
      type: String,
      default: '2px solid #E5E5E5'
    },
    flexWrap: {
      type: String,
      default: 'wrap'
    },
    font: {
      type: String,
      default: '14px'
    },
    actStyle: {
      type: String,
      default: 'border: 2px solid #5e5eee; color: #5e5eee;'
    },
    flex: {
      type: String,
      default: 'row'
    },
    padding: {
      type: String,
      default: '0px'
    },
    parent: {
      type: String,
      default: ''
    },
    parentCn: {
      type: String,
      default: ''
    }
  },
  watch: {
    list(val) {
      if (val) {
        this.$emit('update:current', this.radio.current)
        this.$emit('update:item', this.radio.item)
      }
    },
    current(val) {
      this.radio.current = val
      if (val == -1) {
        this.radio.item = {
          label: '-1',
          value: -1
        }
        this.radio.keys = this.keys
        this.radio.parent = this.parent
        this.radio.parentCn = this.parentCn
        this.$emit('change', this.radio)
      }
    }
  },
  mounted() {
    if (this.modelValue) {
      let idx = undefined
      for (let i in this.list) {
        if (this.list[i][this.value] === this.modelValue) {
          idx = Number(i)
          break
        }
      }
      this.radio.current = idx
      this.$emit('update:current', idx)
    }
  },
  data() {
    return {
      radio: {
        current: this.current,
        item: this.item,
        keys: this.keys,
        parent: this.parent,
        parentCn: this.parentCn,
        value: this.modelValue
      }
    }
  },
  methods: {
    style(index, item) {
      let a = ''
      if (this.radio.current === index) {
        a += this.actStyle
      }
      if (item.url) {
        a += ''
      }
      return a
    },
    isCurrent(index, item) {
      if (this.radio.current == index && this.isDouble) {
        this.radio.current = -1
        this.radio.item = undefined
      } else {
        this.radio.current = index
        this.radio.item = item
        this.radio.value = this.radio.item[this.value] || this.radio.item[this.keys]
      }
      this.$emit('change', this.radio)
      this.$emit('update:current', this.radio.current)
      this.$emit('update:item', this.radio.item)
      this.$emit('update:modelValue', this.radio.value)
    }
  },
}
</script>
<style scoped lang="less">
.ws-radio-list {
  width: inherit;
  height: auto;
  display: flex;
  flex-wrap: v-bind('flexWrap');
  /*flex-wrap: wrap;*/
  box-sizing: border-box;
  gap: v-bind('space');

  .ws-title-status {
    min-width: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: var(--text-main);
    padding: v-bind('padding')
  }
}

.row {
  flex-direction: row;
}

.col {
  flex-direction: column;
}


.radio-child {
  /*
     border: v-bind('border'); */
  border-radius: v-bind('radius');
  font-size: v-bind('font');
  height: v-bind('height');
  width: v-bind('textWidth');
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio-item {
  height: 100%;
  width: 100%;

}

.radio-child:hover {
  opacity: 0.5;
}

.un-act {
  border: v-bind('border');
  color: #5e5eee;
  border-radius: 4px;
  overflow: hidden;
}

.act {
  border: 2px solid #5e5eee;
  color: #5e5eee;
  border-radius: 4px;
  overflow: hidden;
}

.text-row-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .ws-radio-list {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .radio-child {
    flex-shrink: 0;
  }
}
</style>
